import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Data, Hints } from "../../../types/hints";

export interface HintsState {
  pages: Data | null;
  currentFAQsKey: string;
}

const initialState: HintsState = {
  pages: {
    dataProtectionPage: {
      content: {
        de: "",
        en: "",
      },
      type: "",
    },
    faqsPage: {
      content: {
        de: {
          content: {
            title: "",
            content: [],
          },
        },
        en: {
          content: {
            title: "",
            content: [],
          },
        },
      },
      type: "",
    },
    receiverFaqsPage: {
      content: {
        de: [],
        en: [],
      },
      type: "",
    },
    hintsAndTipsPage: {
      content: {
        de: [],
        en: [],
      },
      type: "",
    },
    imprintPage: {
      content: {
        de: "",
        en: "",
      },
      type: "",
    },
    termOfServicePage: {
      content: {
        de: "",
        en: "",
      },
      type: "",
    },
    helpPage: {
      content: {
        de: [],
        en: [],
      },
      type: "",
    },
  },
  currentFAQsKey: "",
};

const hintsSlice = createSlice({
  name: "hintsSlice",
  initialState: initialState,
  reducers: {
    setHints: (state, action: PayloadAction<any>) => {
      const helpData = {
        ...action.payload,
        helpPage: {
          type: "help",
          content: {
            en: {
              title: "Help",
              content: [],
            },
            de: {
              title: "Hilfe",
              content: [],
            },
          },
        },
      };
      state.pages = helpData;
    },
    setCurrentFAQsKey: (state, action: PayloadAction<string>) => {
      state.currentFAQsKey = action.payload;
    },
  },
});

export const { setHints, setCurrentFAQsKey } = hintsSlice.actions;

export default hintsSlice.reducer;
